"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Styled = __importStar(require("./styled"));
const BASE_URL = 'https://static.vente-privee.com/vp5/_web/site/vp/_common/logos/';
/**
 * privalia - black.svg
 * privalia-it-parte-black-2-lines.svg
 * privalia-it-parte-black.svg
 * privalia-it-parte-white-2-lines.svg
 * privalia-it-parte-white.svg
 * privalia-parte-black-2-lines.svg
 * privalia-parte-black.svg
 * privalia-parte-white-2-lines.svg
 * privalia-parte-white.svg
 * privalia-white.svg
 * veepee-black.svg
 * veepee-white.svg
 */
const getLogoSrc = (siteId, isWhite, isLegacy, withParte, isTwoLine) => {
    const twoLines = isTwoLine ? '-2-lines' : '';
    const color = isWhite ? 'white' : 'black';
    const it = siteId === 69 ? '-it' : '';
    const legacy = isLegacy ? '-legacy' : '';
    if ((siteId === 66 || siteId === 69) && !isLegacy) {
        if (!withParte) {
            return `${BASE_URL}privalia-${color}.svg`;
        }
        return `${BASE_URL}privalia${it}-parte-${color}${twoLines}.svg`;
    }
    else if (siteId === 2 || siteId === 7) {
        return `${BASE_URL}veepee${legacy}-gradient-${color}.svg`;
    }
    return `${BASE_URL}veepee${legacy}-${color}.svg`;
};
exports.Logo = (0, react_1.forwardRef)(function Logo(props, ref) {
    const { isLegacy, isTwoLine, isWhite, siteId, withParte } = props, otherProps = __rest(props, ["isLegacy", "isTwoLine", "isWhite", "siteId", "withParte"]);
    const logoSrc = (0, react_1.useMemo)(() => getLogoSrc(siteId, isWhite, isLegacy, withParte, isTwoLine), [siteId, isTwoLine, isWhite, withParte]);
    return (0, jsx_runtime_1.jsx)(Styled.Logo, Object.assign({ ref: ref }, otherProps, { src: logoSrc, alt: "logo" }));
});
exports.default = exports.Logo;
